import { ThemeColorVariable, ThemeFontSizeVariable } from "@caspeco/casper-ui-library.base-ui.theme";
import { Text } from "@caspeco/casper-ui-library.components.text";
import { Flex } from "@caspeco/casper-ui-library.components.flex";
import { AspectRatioWrapper } from "components/aspect-ratio-wrapper/AspectRatioWrapper";
import { AspectRatio } from "types/ui";
import { useCartStore } from "store/cartStore";

interface ICartQuantityBadge {
	/** Top position */
	top?: string;
	/** Right position */
	right?: string;
	/** Left position */
	left?: string;
	/** Bottom position */
	bottom?: string;
}

export function CartQuantityBadge({ top = "0", right = "5px", left, bottom }: ICartQuantityBadge) {
	const { cart } = useCartStore();
	const quantity = cart?.rows.reduce((acc, curr) => acc + curr.quantity, 0);
	if (!quantity) return null;
	return (
		<AspectRatioWrapper $aspectratio={AspectRatio.OneByOne}>
			<Flex
				align="center"
				justify="center"
				h="24px"
				w="auto"
				minW="24px"
				position="absolute"
				borderRadius="50%"
				bg={ThemeColorVariable.Secondary}
				top={top}
				bottom={bottom}
				left={left}
				right={right}
			>
				<Text
					align="center"
					fontWeight="medium"
					fontSize={ThemeFontSizeVariable.Medium}
					color={ThemeColorVariable.OnSecondary}
				>
					{quantity}
				</Text>
			</Flex>
		</AspectRatioWrapper>
	);
}
